import React from 'react';
import { useAppSelector } from '../../../state/hooks';
import { CatiWhomStyles } from './styles';
import getTranslationsByLangOrEng from '../../../utils/getTranslationsByLangOrLang';
import ButtonWithArrowOnHover from '../../buttonWithArrowOnHover/ButtonWithArrowOnHover';
import ok from '../../../assets/images/cati/ok.svg';

export const CatiWhom = () => {
  const { interfaceLanguage } = useAppSelector((state) => state.languages);
  return (
    <CatiWhomStyles>
      <div className="container">
        <h5>
          {getTranslationsByLangOrEng(interfaceLanguage, 'cati_23')}
        </h5>
        <div className="content">
          <h2>
            {getTranslationsByLangOrEng(interfaceLanguage, 'cati_24')}
          </h2>
        </div>
      </div>
      <div className="container">
        <div className="cards">
          <div className="cards-item">
            <img src={ok} alt="CATI ok" />
            <h6>{getTranslationsByLangOrEng(interfaceLanguage, 'cati_25')}</h6>
            <p>{getTranslationsByLangOrEng(interfaceLanguage, 'cati_26')}</p>
          </div>
          <div className="cards-item">
            <img src={ok} alt="CATI ok" />
            <h6>{getTranslationsByLangOrEng(interfaceLanguage, 'cati_27')}</h6>
            <p>{getTranslationsByLangOrEng(interfaceLanguage, 'cati_28')}</p>
          </div>
          <div className="cards-item">
            <img src={ok} alt="CATI ok" />
            <h6>{getTranslationsByLangOrEng(interfaceLanguage, 'cati_29')}</h6>
            <p>{getTranslationsByLangOrEng(interfaceLanguage, 'cati_30')}</p>
          </div>
          <div className="cards-item">
            <img src={ok} alt="CATI ok" />
            <h6>{getTranslationsByLangOrEng(interfaceLanguage, 'cati_31')}</h6>
            <p>{getTranslationsByLangOrEng(interfaceLanguage, 'cati_32')}</p>
          </div>
          <div className="cards-item">
            <img src={ok} alt="CATI ok" />
            <h6>{getTranslationsByLangOrEng(interfaceLanguage, 'cati_33')}</h6>
            <p>{getTranslationsByLangOrEng(interfaceLanguage, 'cati_34')}</p>
          </div>
          <div className="cards-item">
            <img src={ok} alt="CATI ok" />
            <h6>{getTranslationsByLangOrEng(interfaceLanguage, 'cati_35')}</h6>
            <p>{getTranslationsByLangOrEng(interfaceLanguage, 'cati_36')}</p>
          </div>
        </div>
      </div>

      <div className="btn-container">
        <ButtonWithArrowOnHover
          onClick={() => {
            const elem = document.getElementById('form');
            elem!.scrollIntoView({ block: 'start', behavior: 'smooth' });
          }}
          arrowColor="#fff"
          textColor="#fff"
          borderColor="#000"
          borderOnHover="#000"
          background="#000"
          className="btn"
          hoverBackground="transparent"
          hoverTextColor="#000"
          text={getTranslationsByLangOrEng(
            interfaceLanguage,
            'cati_3',
          )}
        />
      </div>
    </CatiWhomStyles>
  );
};
